<re-alert *ngIf="successAlert" [type]="successAlert.type" (close)="successAlert = null">{{ successAlert.message }}</re-alert>
<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb px-0 pt-0">
    <li class="breadcrumb-item"><a [routerLink]="['/ect/customers']">Home</a></li>

  </ol>
</nav>

<h1>Stack Details</h1>
<div *ngIf="stackId">
  <div class="row">
    <div class="col-xl-3 col-lg-4 col-md-6 form-group">
      <label class="mb-1">Stack Name</label>
      <div>{{this.stackName}}</div>
    </div>
  </div>
</div>

<button (click)="goBack()" *ngIf="!editProfile && stackId!=0" class="btn btn-default afterDiv">Back</button>

<fieldset [disabled]="isReadOnlyUser ? 'disabled' : null">
<form *ngIf="!newConfig" action="" id="parameterDetailForm" [formGroup]="parameterDetailForm">
  <section id="section1" class="canexpandcollapse mb-1" style="clear: both;" >
    <h2>Parameters</h2>
    <div class="row lrmar7n">
      <div class="col-md-5 col-lg-3 col-xl-3 px-2 form-group">
        <label for="parameterKey" class="mb-1">Key</label>
        <input  formControlName="key" id="parameterKey" type="text" name="" class="form-control"  (input)="this.parameter.value=checkDefaultText()">
        <small *ngIf="parameterDetailForm.controls['key'].hasError('blank') && parameterDetailForm.controls['key'].touched" class="text-danger">Please enter the Key.</small>
      </div>

      <div class="col-md-7 col-lg-5 col-xl-5 px-2 form-group" *ngIf="checkSelect()">
        <label for="parameterValue" class="mb-1">Value</label>
        <span *ngIf="false && !gsEnabled">{{parameterService.getEnabledDisableText(parameter.value)}}</span>
        <span *ngIf="false && gsEnabled">{{parameterService.getGSDisplayText(parameter.value)}}</span>
        <select2 *ngIf="!gsEnabled" formControlName="value" id="parameterValue1" [settings]="{placeholder: 'False',width:'100%', minimumResultsForSearch: -1}" [options]="enabledDisableData"></select2>
        <select2 *ngIf="gsEnabled" formControlName="value" id="parameterValue2" [settings]="{placeholder: 'First Name &quot;Preferred Name&quot; Last Name',width:'100%', minimumResultsForSearch: -1}" [options]="gsEnabledData"></select2>
        <small *ngIf="parameterDetailForm.controls['value']?.errors?.error" class="text-danger">{{parameterDetailForm.controls['value'].errors?.message}}</small>
        <small *ngIf="errorMessage" class="text-danger">{{errorMessage}}</small>
      </div>

      <div class="col-md-7 col-lg-5 col-xl-5 px-2 form-group" *ngIf="!checkSelect()">
        <label for="parameterValue" class="mb-1">Value</label>
        <input type="text" name="" class="form-control" formControlName="value" id="parameterValue"/>
        <small *ngIf="parameterDetailForm.controls['value']?.errors?.error && parameterDetailForm.touched" class="text-danger">{{parameterDetailForm.controls['value'].errors?.message}}</small>
        <small *ngIf="errorMessage" class="text-danger">{{errorMessage}}</small>
      </div>
      <div class="col-12 col-lg-4 col-xl-4 px-2 form-group">
        <label class="d-none d-lg-block mb-1">&nbsp;</label>
        <button [disabled]="!stackId" type="button" [disabled]="!parameterDetailForm.valid" (click)="addParameter()" class="btn btn-primary"> Add Parameter</button>
      </div>
    </div>
  </section>
</form>
</fieldset>

<form #form='ngForm'  name="multiParameterEdit">
  <div class="d-flex justify-content-sm-start justify-content-md-between align-items-center mb-2">
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-1">
          <button class="btn btn-primary"  [disabled]="isReadOnlyUser" *ngIf="!editParameters && !newConfig" (click)="editParametersClicked()">Edit</button>
          <button class="btn btn-success" *ngIf="editParameters" [disabled]="form.dirty && form.invalid" (click)="updateParameter()">Save</button>
          <button class="btn btn-danger" *ngIf="editParameters" [disabled]="!somethingIsChecked" (click)="deleteBatchParameters()">Delete</button>
          <button class="btn btn-cancel" *ngIf="editParameters" (click)="cancelParameters()">Cancel</button>
        </div>
      </div>
    </div>
    <div class="text-right" style="margin-bottom:15px" *ngIf="!newConfig">
      <a (click)="expandAll()" [routerLink]="[]">Expand All</a> | <a (click)="collapseAll()" [routerLink]="[]">Collapse All</a>
    </div>
  </div>

  <div *ngIf="!newConfig" id="accordion_products" class="collapsible-panel-group panel-group panel-bordered" role="tablist" aria-multiselectable="true">
    <div id="panel_{{productName}}" class="card mb-0" *ngFor="let productName of getProductKeys()">
      <div id="panelHeading_{{productName}}" class="card-header stack-detail-panel-header" role="tab"  (click)="isProductCollapsed[productName]=!isProductCollapsed[productName]">
        <a href="javascript:;" class="btn btn-link stack-detail-panel-title" data-toggle="collapse" data-target="#panelContent1_{{productName}}">{{productName}}</a>
        <span *ngIf="isCareAssistGroup(productName)" class="stack-detail-panel-actions">
          <i *ngIf="!caHotReloading" class="fa fa-refresh" (click)="refreshClicked($event)" title="Hot Reload Stack CareAssist properties"></i>
          <i *ngIf="caHotReloading" class="fa fa-spinner fa-spin" [style.color]="getNgStyleColorBasedOnStatus('LOADING')" aria-hidden="true"></i>
        </span>
      </div>

      <div  id="panelContent_{{productName}}" class="card-body" [ngbCollapse]="isProductCollapsed[productName]">
        <div class="table-responsive">
          <table class="table table-striped table-bordered user-list" [(re-column-order-data)]="groupedParameters[productName]">
            <thead class="thead">
            <tr>
              <th class="w70p">
                <div class="form-check text-center">
                  <input type="checkbox" id="cb_slselectall_{{productName}}" name="checkAll" class="form-check-input" (change)="checkAllCheckBox($event,productName)" [disabled]="!editParameters">
                  <label class="form-check-label" for="cb_slselectall_{{productName}}">&nbsp;</label>
                </div>
              </th>
              <!--if youw ant to sort by default by key but screen will flicker as api returns id desc re-column-order-default="desc"-->
              <th class="" re-column-order-property="key" re-column-order-default="asc" style="width:20%">Parameter</th>
              <th class="" re-column-order-property="value" style="width:40%">Value</th>
              <th class="">Errors</th>
            </tr>
            </thead>

            <tbody *ngIf="editParameters">
            <tr *ngFor="let u of groupedParameters[productName]; let index = index">
              <td>
                <div class="form-check text-center">
                  <input type="checkbox" id="cb_{{u.id}}" value="{{u.id}}" name="{{u.id}}" class="form-check-input" (change)="onCheck()" [(ngModel)]="groupedParameters[productName][index].checked">
                  <label class="form-check-label" for="cb_{{u.id}}"></label>
                </div>
              </td>
              <td>
                <div class="field-editable">
                  <input #keycontrol="ngModel" type="text" required type="text" name="multiParameterEditKey_{{productName}}_{{u.id}}" class="form-control" [(ngModel)]="u.key">
                  <small *ngIf="keycontrol.errors?.required && form.touched" class="text-danger">Please enter the Key.</small>
                </div>
              </td>
              <td>
                <div class="field-editable" *ngIf="!checkSelectMultiEdit(u.key)">
                  <input  #valuecontrol="ngModel" parameterValue [parameterKey]="keycontrol.control" [snfCorpOid]="corpOid" [snfAppUrl]="snfAppUrl"  [triggerValidationOnDirty]="true" type="text" name="multiParameterEditValue_{{productName}}_{{u.id}}" class="form-control" [(ngModel)]="u.value" (keypress)="onChange(u.value, $event,keycontrol.value)">
                  <small *ngIf="valuecontrol.errors?.error" name="multiParameterEditValue_{{productName}}_{{index}}" class="text-danger">{{valuecontrol.errors?.message}}</small>
                </div>

                <div *ngIf="checkSelectMultiEdit(u.key)">
                  <span *ngIf="false && !gsEnabled">{{parameterService.getEnabledDisableText(u.value)}}</span>
                  <span *ngIf="false && gsEnabled">{{parameterService.getGSDisplayText(u.value)}}</span>
                  <select2 *ngIf="!gsEnabled" [(ngModel)]="u.value" [settings]="{placeholder: 'False',width:'100%', minimumResultsForSearch: -1}" name="multiParameterEditValue_{{productName}}_{{u.id}}" [options]="enabledDisableData"></select2>
                  <select2 *ngIf="gsEnabled" [(ngModel)]="u.value" [settings]="{placeholder: 'First Name &quot;Preferred Name&quot; Last Name',width:'100%', minimumResultsForSearch: -1}" name="multiParameterEditValue_{{productName}}_{{u.id}}}" [options]="gsEnabledData"></select2>
                  <small name="multiParameterEditValue_{{productName}}_{{index}}" class="text-danger">{{u.error}}</small>
                </div>
              </td>
              <td>
                <a style="color:#ff0000;">{{ u.errorMessage }}</a>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="!editParameters">
            <tr *ngFor="let u of groupedParameters[productName]">
              <td>
                <div class="form-check text-center">
                  <input type="checkbox" id="cb_{{u.id}}" name="" class="form-check-input" [disabled]="true">
                  <label class="form-check-label" for="cb_{{u.id}}">&nbsp;</label>
                </div>
              </td>
              <td>
                <a>{{ u.key }}</a>
              </td>
              <td>
                <a class="fa" [ngClass]="{'fa-fw': u.status === '' || u.status === '404', 'fa-spinner fa-spin': u.status === 'LOADING', 'fa-check': u.status === 'UP', 'fa-times': u.status === 'DOWN'}"
                   [ngStyle] [style.color] = "getNgStyleColorBasedOnStatus(u.status)"
                   aria-hidden="true"></a>
                {{ u.value }}
              </td>
              <td>
                <a style="color:#ff0000;">{{ u.errorMessage }}</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</form>
